/**
 * Publish RHH custom events to Shopify Customer Events so the first-party
 * pixel can collect them. Does not load GA4/Meta. Mirrors GTM RHH Storefront QA
 * selectors (do not turn those GTM tags off yet).
 *
 * Also forwards Elevar dl_select_item, window JS errors (GA4 exception),
 * Klaviyo form-modal open, and Bundler checkout-prompt popup.
 */
(function () {
  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
        Shopify.analytics.publish(name, data || {});
      }
    } catch (e) {}
  }

  window.__rhhFpPublish = publish;

  function persistIdentity(partial) {
    if (!partial) return;
    var ttl = 7776000;
    function readCookie(name) {
      try {
        var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : '';
      } catch (e) {
        return '';
      }
    }
    var current = {};
    var raw = readCookie('rhh_fp_id');
    if (raw) {
      var parts = raw.split('|');
      for (var i = 0; i < parts.length; i++) {
        var eq = parts[i].indexOf('=');
        if (eq < 1) continue;
        var k = parts[i].slice(0, eq);
        var v = parts[i].slice(eq + 1);
        try {
          v = decodeURIComponent(v);
        } catch (e2) {}
        if (k === 'em' && v) current.email = v;
        else if (k === 'ph' && v) current.phone = v;
        else if (k === 'cid' && v) current.customer_id = v;
        else if (k === 'kx' && v) current.kx = v;
      }
    }
    if (partial.email) current.email = partial.email;
    if (partial.phone) current.phone = partial.phone;
    if (partial.customer_id) current.customer_id = String(partial.customer_id);
    if (partial.kx) current.kx = partial.kx;
    var blobParts = [];
    if (current.email) blobParts.push('em=' + encodeURIComponent(current.email));
    if (current.phone) blobParts.push('ph=' + encodeURIComponent(current.phone));
    if (current.customer_id) blobParts.push('cid=' + encodeURIComponent(current.customer_id));
    if (current.kx) blobParts.push('kx=' + encodeURIComponent(current.kx));
    if (!blobParts.length) return;
    try {
      document.cookie = 'rhh_fp_id=' + encodeURIComponent(blobParts.join('|')) + ';path=/;max-age=' + ttl + ';SameSite=Lax';
    } catch (e3) {}
    publish('rhh_identity', current);
  }

  function path() {
    try {
      return window.location.pathname || "";
    } catch (e) {
      return "";
    }
  }

  function closestMatch(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  if (document.documentElement.getAttribute("data-template") === "404") {
    publish("rhh_404", { page_path: path(), page_title: document.title || "" });
  }

  document.addEventListener(
    "click",
    function (e) {
      var t = e.target;
      if (!t) return;
      if (closestMatch(t, ".rhh-purchase-atc, .rhh-purchase-atc *")) {
        publish("rhh_atc_click", { atc_source: "main", page_path: path() });
        return;
      }
      if (closestMatch(t, ".rhh-sticky-atc-pdp__atc, .rhh-sticky-atc-pdp__atc *")) {
        publish("rhh_atc_click", { atc_source: "sticky", page_path: path() });
        return;
      }
      if (closestMatch(t, '.cart__checkout, button[name="checkout"], .m-cart__checkout-button')) {
        publish("rhh_checkout_click", { page_path: path() });
        return;
      }
      if (closestMatch(t, ".m-product-option__input, .rhh-product-variant-atf label")) {
        publish("rhh_variant_change", { page_path: path() });
        return;
      }
      if (closestMatch(t, ".rhh-subscribe-button, .custom-subscribe-button")) {
        publish("rhh_subscribe_click", { page_path: path() });
        return;
      }
      var start = closestMatch(t, 'a[href*="/pages/start-here"]');
      if (start) {
        publish("rhh_start_here_click", { page_path: path() });
      }
    },
    true
  );

  function watchSticky() {
    if (!window.IntersectionObserver) return;
    var seen = false;
    var nodes = document.querySelectorAll("sticky-atc, .rhh-sticky-atc-pdp__host");
    if (!nodes.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (seen) return;
          if (entries[i].isIntersecting && entries[i].intersectionRatio >= 0.5) {
            seen = true;
            publish("rhh_sticky_atc_visible", { page_path: path() });
            io.disconnect();
          }
        }
      },
      { threshold: [0.5] }
    );
    for (var j = 0; j < nodes.length; j++) io.observe(nodes[j]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watchSticky);
  } else {
    watchSticky();
  }

  var overlaySeen = {};

  function onceOverlay(name) {
    if (overlaySeen[name]) return;
    overlaySeen[name] = true;
    publish(name, { page_path: path(), page_type: "overlay" });
  }

  function overlayVisible(el) {
    if (!el) return false;
    if (el.classList && el.classList.contains("bndlr-hidden")) return false;
    var st;
    try {
      st = window.getComputedStyle(el);
    } catch (e) {
      return false;
    }
    if (!st || st.display === "none" || st.visibility === "hidden") return false;
    var r = el.getBoundingClientRect();
    return r.width > 20 && r.height > 20;
  }

  function scanOverlays() {
    if (overlayVisible(document.querySelector("#bndlr-discount-message"))) {
      onceOverlay("rhh_overlay_bundler");
    }
    if (
      overlayVisible(
        document.querySelector("[data-testid=\"klaviyo-form-modal\"], .klaviyo-form-modal")
      )
    ) {
      onceOverlay("rhh_overlay_klaviyo");
    }
  }

  document.addEventListener("bundler:checkout_prompt_shown", function () {
    onceOverlay("rhh_overlay_bundler");
  });

  window.addEventListener("klaviyoForms", function (e) {
    var type = e && e.detail && e.detail.type;
    if (type === "open") onceOverlay("rhh_overlay_klaviyo");
    if (type === "submit") {
      var meta = (e.detail && (e.detail.metaData || e.detail.metadata)) || {};
      var email = meta.email || meta.$email || (e.detail && e.detail.email) || "";
      persistIdentity({ email: email });
      publish("subscribe_email", {
        page_path: path(),
        page_type: "klaviyo",
        email: email,
      });
    }
  });

  if (window.MutationObserver) {
    var overlayMo = new MutationObserver(scanOverlays);
    overlayMo.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style"],
    });
  }
  scanOverlays();

  function firstSelectProduct(item) {
    var click = item && item.ecommerce && item.ecommerce.click;
    var products = (click && click.products) || [];
    return products[0] || {};
  }

  function leadType(item) {
    return String((item && item.lead_type) || "").toLowerCase();
  }

  function forwardDataLayer(item) {
    if (!item || typeof item !== "object") return;
    if (item.event === "dl_login") {
      persistIdentity({
        email: item.email || item.customer_email || "",
        customer_id: item.customer_id || "",
      });
      publish("login", {
        page_path: path(),
        page_type: "account",
        email: item.email || item.customer_email || "",
        customer_id: item.customer_id ? String(item.customer_id) : "",
      });
      return;
    }
    if (item.event === "dl_sign_up") {
      persistIdentity({
        email: item.email || item.customer_email || "",
        customer_id: item.customer_id || "",
      });
      publish("sign_up", {
        page_path: path(),
        page_type: "account",
        email: item.email || item.customer_email || "",
        customer_id: item.customer_id ? String(item.customer_id) : "",
      });
      return;
    }
    if (item.event === "dl_subscribe") {
      var lt = leadType(item);
      var name = lt.indexOf("phone") >= 0 ? "subscribe_phone" : "subscribe_email";
      persistIdentity({
        email: item.email || "",
        phone: item.phone || item.customer_phone || "",
      });
      publish(name, {
        page_path: path(),
        page_type: lt || "email",
        email: item.email || "",
        phone: item.phone || item.customer_phone || "",
      });
      return;
    }
    if (item.event !== "dl_select_item") return;
    var p = firstSelectProduct(item);
    publish("select_item", {
      page_path: path(),
      page_type: "collection",
      product_id: p.product_id ? String(p.product_id) : "",
      variant_id: p.variant_id ? String(p.variant_id) : "",
      product_title: p.name || "",
      product_handle: p.handle || "",
    });
  }

  window.dataLayer = window.dataLayer || [];
  var originalPush = window.dataLayer.push;
  window.dataLayer.push = function () {
    for (var i = 0; i < arguments.length; i++) {
      try {
        forwardDataLayer(arguments[i]);
      } catch (e) {}
    }
    return originalPush.apply(window.dataLayer, arguments);
  };

  function exceptionPayload(message) {
    var text = String(message || "error").slice(0, 200);
    publish("exception", {
      page_path: path(),
      page_type: "exception",
      page_title: text,
    });
  }

  window.addEventListener("error", function (e) {
    exceptionPayload((e && e.message) || "error");
  });
  window.addEventListener("unhandledrejection", function (e) {
    var reason = e && e.reason;
    exceptionPayload(reason && reason.message ? reason.message : reason || "unhandledrejection");
  });
})();
